import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

const zhCNMessages = {
  "edu.pages.dashboard.title": "EDU 工作台",
  "edu.pages.dashboard.summary": "统一工作台优先承接负责范围内的经营总览、待处理事项与业务中心入口。",
  "edu.pages.dashboard.messages.loadFailed": "工作台概览加载失败",
  "edu.pages.dashboard.tags.overviewDriven": "经营总览驱动",
  "edu.pages.dashboard.tags.dualCenter": "课程 + 培训项目双中心",
  "edu.pages.dashboard.labels.centerEntries": "业务中心入口",
  "edu.pages.dashboard.empty.risk": "当前负责范围内暂无需要优先介入的风险异常，可以继续查看待处理事项或整体进展。",
  "edu.pages.dashboard.empty.todo": "当前负责范围内暂无待处理事项，说明草稿发布、作业批改和手动推进动作暂时已清空。",
  "edu.pages.dashboard.empty.progress": "当前负责范围内暂无更多进展摘要，先通过业务中心入口进入课程、教学计划或培训项目查看细节。",
} satisfies MessageTree;

export const eduDashboardPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": zhCNMessages,
  en: zhCNMessages,
  ja: zhCNMessages,
};
